// @flow
import type { ERROR_TYPE } from './common';
import type { USER_TYPE } from './users';

export type PARENT_TYPE = {
  id: number,
  first_name: string,
  last_name: string,
  email: string,
  user: USER_TYPE,
  is_emergency_contact: boolean
};

export type PARENT_FETCH_STARTED_TYPE = {
  type: 'PARENT_FETCH_STARTED',
  payload: number
};
export const PARENT_FETCH_STARTED = 'PARENT_FETCH_STARTED';

export type PARENT_FETCH_SUCCEED_TYPE = {
  type: 'PARENT_FETCH_SUCCEED',
  payload: PARENT_TYPE
};
export const PARENT_FETCH_SUCCEED = 'PARENT_FETCH_SUCCEED';

export type PARENT_FETCH_FAILED_TYPE = {
  type: 'PARENT_FETCH_FAILED',
  payload: ERROR_TYPE
};
export const PARENT_FETCH_FAILED = 'PARENT_FETCH_FAILED';

export type PARENTS_REGISTERED_TYPE = {
  type: 'PARENTS_REGISTERED',
  payload: {
    entities: {[number]: PARENT_TYPE}
  }
};
export const PARENTS_REGISTERED = 'PARENTS_REGISTERED';

export type UPDATE_PARENT_STARTED_TYPE = {
  type: 'UPDATE_PARENT_STARTED',
  payload: Object
};
export const UPDATE_PARENT_STARTED = 'UPDATE_PARENT_STARTED';

export type UPDATE_PARENT_SUCCEED_TYPE = {
  type: 'UPDATE_PARENT_SUCCEED',
  payload: PARENT_TYPE
};
export const UPDATE_PARENT_SUCCEED = 'UPDATE_PARENT_SUCCEED';

export type UPDATE_PARENT_FAILED_TYPE = {
  type: 'UPDATE_PARENT_FAILED',
  payload: ERROR_TYPE,
}
export const UPDATE_PARENT_FAILED = 'UPDATE_PARENT_FAILED';

export type PARENT_ACTION_TYPE =
  | PARENT_FETCH_STARTED_TYPE
  | PARENT_FETCH_SUCCEED_TYPE
  | PARENT_FETCH_FAILED_TYPE
  | PARENTS_REGISTERED_TYPE
  | UPDATE_PARENT_SUCCEED_TYPE
  | UPDATE_PARENT_STARTED_TYPE
  | UPDATE_PARENT_FAILED_TYPE;



// WEBPACK FOOTER //
// ./src/scripts/types/parents.js